import * as React from "react";

const PGSideBar = () => {

  return (
    <>
      <div className='patent-guide-sidebar'>
        <h2>Menu</h2>
        <div class="just-padding">
          <div class="list-group list-group-root well">
            <a href="/" class="list-group-item border-0 sidebar-bg ps-0">Home</a>
            <a href="/#who-we-are" class="list-group-item border-0 sidebar-bg ps-0">About</a>
            <a href="/inventor-resources" class="list-group-item border-0 sidebar-bg ps-0">Resources</a>
            <div class="list-group">
              <a href="#" class="list-group-item border-0 sidebar-bg">USPTO Pro Bono Program</a>
              <a href="#" class="list-group-item border-0 sidebar-bg">Patent Guide</a>
              <a href="#" class="list-group-item border-0 sidebar-bg">Press Release</a>
            </div>
            <a href="/patentfaqs" class="list-group-item border-0 sidebar-bg ps-0">Patent FAQs</a>
            <div class="list-group">
              <a href="/patentfaqs/ip-basics" class="list-group-item border-0 sidebar-bg">IP Basics</a>
              <a href="/patentfaqs/patent-basics" class="list-group-item border-0 sidebar-bg">Patent Basics</a>
              <div class="list-group">
                <a href="/patentfaqs/patent-basics" class="list-group-item border-0 sidebar-bg">Patent Basics</a>
                <a href="/patentfaqs/set-up-an-account-with-uspto" class="list-group-item border-0 sidebar-bg">Set up an Account with the USPTO</a>
                <a href="/patentfaqs/need-for-patent-attorney-or-agent" class="list-group-item border-0 sidebar-bg">Need for a Patent Attorney or Agent</a>
              </div>
              <a href="/patentfaqs/provisional-patent-application" class="list-group-item border-0 sidebar-bg">Provisional Patent Application</a>
              <div class="list-group">
                <a href="/patentfaqs/provisional-patent-application" class="list-group-item border-0 sidebar-bg">Provisional Patent Application</a>
                <a href="/patentfaqs/provisional-builder" class="list-group-item border-0 sidebar-bg">Provisional Builder</a>
                <a href="/patentfaqs/after-submit-ppa" class="list-group-item border-0 sidebar-bg">After you submit a PPA</a>
              </div>

              <a href="/patentfaqs/utility-patent-application" class="list-group-item border-0 sidebar-bg">Utility Patent Application</a>
              <div class="list-group">
                <a href="/patentfaqs/utility-patent-application" class="list-group-item border-0 sidebar-bg">Utility Patent Application</a>
                <a href="/patentfaqs/file-a-utility-patent-application" class="list-group-item border-0 sidebar-bg">File a Utility Patent Application</a>
                <a href="/patentfaqs/what-happens-after-filing-utility-application" class="list-group-item border-0 sidebar-bg">What Happens After Filing Utility Application?</a>
              </div>
              <a href="/patentfaqs/respond-to-office-action" class="list-group-item border-0 sidebar-bg">Respond to Office Actions</a>
              <a href="/patentfaqs/patent-issued" class="list-group-item border-0 sidebar-bg">Patent Issurance</a>
            </div>


            <a href="/provisional-builder" class="list-group-item border-0 sidebar-bg ps-0">ProvisionalBuilder</a>
            <a href="/docket" class="list-group-item border-0 sidebar-bg ps-0">Login</a>
            <a href="/contact" class="list-group-item border-0 sidebar-bg ps-0">Contact</a>
            <a href="/blog" class="list-group-item border-0 sidebar-bg ps-0">Blogs</a>

          </div>
          <hr />
        </div>
        <p>
          <strong>Disclaimer</strong> Communications between you and Inventiv Foundation are protected by our Privacy Policy but not by the attorney-client privilege or as work product. Inventiv Foundation, Inc. can connect you to independent attorneys and self-help services at your specific direction. We are not a law firm or a substitute for an attorney or law firm. We cannot provide any kind of advice, explanation, opinion, or recommendation about possible legal rights, remedies, defenses, options, selection of forms or strategies. Your access to the website is subject to our Terms of Use.
        </p>
        <hr />
        <h2>Tags</h2>
        <div class="tagcloud">
          <a href="/tag/patent-review" class="tag-cloud-link tag-link-160 tag-link-position-1"
            aria-label="Patent Review ">Patent Review</a>
        </div>
      </div>
    </>
  )
}

export default PGSideBar